

import state from './moduleSecteursState.js'
import mutations from './moduleSecteursMutations.js'
import actions from './moduleSecteursActions.js'
import getters from './moduleSecteursGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

